/**
 * toThreeClip — kernel ClipData → Three AnimationClip (ADR-008 §2i, the apply
 * direction): viewport playback and the export path both consume this. The
 * inverse of convertClip's happy path; morph tracks reattach by target name.
 * Depends on: three, @harryhausen/kernel (types). Depended on by: app, export.
 */
import {
  AnimationClip,
  KeyframeTrack,
  NumberKeyframeTrack,
  QuaternionKeyframeTrack,
  VectorKeyframeTrack,
} from 'three';
import type { ClipData } from '@harryhausen/kernel';

export function toThreeClip(clip: ClipData): AnimationClip {
  const tracks: KeyframeTrack[] = clip.tracks.map((t) => {
    const times = Array.from(t.times);
    const values = Array.from(t.values);
    switch (t.path) {
      case 'rotation':
        return new QuaternionKeyframeTrack(`${t.target}.quaternion`, times, values);
      case 'translation':
        return new VectorKeyframeTrack(`${t.target}.position`, times, values);
      case 'scale':
        return new VectorKeyframeTrack(`${t.target}.scale`, times, values);
      case 'morph':
        return new NumberKeyframeTrack(`.morphTargetInfluences[${t.target}]`, times, values);
    }
  });
  return new AnimationClip(clip.name, clip.durationSec, tracks);
}
